const breakpoints = {
  BREAKPOINTS: {
    SMALL: 0,
    MEDIUM: 768,
    LARGE: 1024,
    X_LARGE: 1440
  },
  DEVICES: {
    SMALL: 'SM',
    MEDIUM: 'MD',
    LARGE: 'LG',
    X_LARGE: 'XL'
  }
};

export default breakpoints;
